
import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import LocationMap from './locationMap'
import StoreItem from './StoreItem';
import { useEffect } from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { connect, useSelector } from 'react-redux';
import { getStores, getCitiesWeb } from '../../Redux/actions/store';
import Header from '../../Components/Header';
import GoBack from '../BackButton/GoBack';
import * as geolib from 'geolib';
import { useTranslation } from 'react-i18next';
import StoreLocationsMap from '../../Components/StoreLocationsMap';
import StoreLocationsGoogleMap from "../../Components/StoreLocationsGoogle";
import Footer from '../../Components/Footer';

interface GeoJSONPoint {
  latitude: number,
  longitude: number
}


function StoreLocator(props: any) {
  const storeList = useSelector((state: any) => state.store.storeList);
  const pickupStoreList = useSelector((state: any) => state.store.pickupStoreList);
  const deliveryStoreList = useSelector((state: any) => state.store.deliveryStoreList);
  let [channel, setChannelTab] = React.useState("All");
  let [selectedStore, setSelectedStore]: any = React.useState(null);
  let [zoom, setZoom] = React.useState(11);
  let [zoomChangeSeed, setZoomChangeSeed] = React.useState(Math.random());
  const cityList = useSelector((state: any) => state.store.cityList);

  const [filterStores, setFilterStores] = React.useState(storeList)
  const [markers, setMarkers] = React.useState([])
  const [filterDelivery, setFilterDelivery] = React.useState(deliveryStoreList)
  const [deliveryMarkers, setDeliveryMarkers] = React.useState([])
  const [filterPickup, setFilterPickup] = React.useState(pickupStoreList)
  const [pickupMarkers, setPickupMarkers] = React.useState([])
  const [initialMapCenter, setInitalMapCenter] = React.useState<number[]>([]);

  const [city, setCity] = React.useState("all");
  const [query, setQuery] = React.useState('');

  useEffect(() => {
    props.getStores();
    props.getCitiesWeb();
  }, [])

  useEffect(() => {
    selectedStore && setInitalMapCenter([selectedStore.lng, selectedStore.lat]);
  }, [selectedStore])

  // Find Center of given lat lngs
  function getCenter(points: GeoJSONPoint[]) {
    if (points.length > 0) {
      const centerPoint = geolib.getCenterOfBounds(points);
      if (!centerPoint) return [];
      return [centerPoint.longitude, centerPoint.latitude]
    } else {
      return []
    }
  };

  const handleCity = (event: any) => {
    if (event.target.value !== "all") {
      setCity(event.target.value);
      setZoom(10)
      setZoomChangeSeed(Math.random())
      let updatedStoreList = storeList.filter((item: any) => {
        return item.city_id === event.target.value;
      });
      setFilterStores(updatedStoreList)

      const points: GeoJSONPoint[] = updatedStoreList.map((item: any) => {
        return {
          latitude: item.lat,
          longitude: item.lng
        }
      }).filter((obj: { latitude: number }) => obj.latitude > 0);
      const centerPoint = getCenter(points);
      centerPoint && centerPoint.length > 0 && setInitalMapCenter(centerPoint)
      let updatedDeliveryList = deliveryStoreList.filter((item: any) => {
        return item.city_id === event.target.value;
      });
      setFilterDelivery(updatedDeliveryList)

      let updatedPickupList = pickupStoreList.filter((item: any) => {
        return item.city_id === event.target.value;
      });
      setFilterPickup(updatedPickupList)
      let storesmarkers = updatedStoreList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setMarkers(storesmarkers)
      let deliverymarkers = updatedDeliveryList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setDeliveryMarkers(deliverymarkers)
      let pickupmarkers = updatedPickupList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setPickupMarkers(pickupmarkers)

    } else {
      setZoom(5)
      setZoomChangeSeed(Math.random())
      setCity(event.target.value);
      setFilterStores(storeList)
      setFilterDelivery(deliveryStoreList)
      setFilterPickup(pickupStoreList)
      const points: GeoJSONPoint[] = storeList.map((item: any) => {
        return {
          latitude: item.lat,
          longitude: item.lng
        }
      }).filter((obj: { latitude: number }) => obj.latitude > 0);
      const centerPoint = getCenter(points);
      centerPoint && centerPoint.length > 0 && setInitalMapCenter(centerPoint)
      let storesmarkers = storeList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setMarkers(storesmarkers)

      let deliverymarkers = deliveryStoreList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setDeliveryMarkers(deliverymarkers)
      let pickupmarkers = pickupStoreList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setPickupMarkers(pickupmarkers)
    }
  };
  const handleQuery = (event: any) => {
    setCity("all")
    setZoom(5)
    setZoomChangeSeed(Math.random())
    if (query !== "") {
      setQuery(event.target.value);
      let updatedStoreList = storeList.filter((item: any) => {
        return item.store_name.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1;
      });
      setFilterStores(updatedStoreList)
      const points: GeoJSONPoint[] = updatedStoreList.map((item: any) => {
        return {
          latitude: item.lat,
          longitude: item.lng
        }
      }).filter((obj: { latitude: number }) => obj.latitude > 0);
      const centerPoint = getCenter(points);
      centerPoint && centerPoint.length > 0 && setInitalMapCenter(centerPoint)
      let updatedDeliveryList = deliveryStoreList.filter((item: any) => {
        return item.store_name.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1;
      });
      setFilterDelivery(updatedDeliveryList)

      let updatedPickupList = pickupStoreList.filter((item: any) => {
        return item.store_name.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1;
      });
      setFilterPickup(updatedPickupList)
      let storesmarkers = updatedStoreList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setMarkers(storesmarkers)
      let deliverymarkers = updatedDeliveryList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setDeliveryMarkers(deliverymarkers)
      let pickupmarkers = updatedPickupList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setPickupMarkers(pickupmarkers)
    } else {
      setQuery(event.target.value);
      setFilterStores(storeList)
      setFilterDelivery(deliveryStoreList)
      setFilterPickup(pickupStoreList)
      const points: GeoJSONPoint[] = storeList.map((item: any) => {
        return {
          latitude: item.lat,
          longitude: item.lng
        }
      }).filter((obj: { latitude: number }) => obj.latitude > 0);
      const centerPoint = getCenter(points);
      centerPoint && centerPoint.length > 0 && setInitalMapCenter(centerPoint)
      let storesmarkers = storeList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setMarkers(storesmarkers)

      let deliverymarkers = deliveryStoreList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setDeliveryMarkers(deliverymarkers)
      let pickupmarkers = pickupStoreList.map((item: any) => {
        return {
          markerPopupName: item.store_name,
          coordinates: {
            lat: item.lat,
            lng: item.lng,
          }
        }
      });
      setPickupMarkers(pickupmarkers)
    }
  };
  useEffect(() => {
    setFilterStores(storeList)
    setFilterDelivery(deliveryStoreList)
    setFilterPickup(pickupStoreList)
    const points: GeoJSONPoint[] = storeList.map((item: any) => {
      return {
        latitude: item.lat,
        longitude: item.lng
      }
    }).filter((obj: { latitude: number }) => obj.latitude > 0);
    const centerPoint = getCenter(points);
    centerPoint && centerPoint.length > 0 && setInitalMapCenter(centerPoint)
    let storesmarkers = storeList.map((item: any) => {
      return {
        markerPopupName: item.store_name,
        coordinates: {
          lat: item.lat,
          lng: item.lng,
        }
      }
    });
    setMarkers(storesmarkers)

    let deliverymarkers = deliveryStoreList.map((item: any) => {
      return {
        markerPopupName: item.store_name,
        coordinates: {
          lat: item.lat,
          lng: item.lng,
        }
      }
    });
    setDeliveryMarkers(deliverymarkers)
    let pickupmarkers = pickupStoreList.map((item: any) => {
      return {
        markerPopupName: item.store_name,
        coordinates: {
          lat: item.lat,
          lng: item.lng,
        }
      }
    });
    setPickupMarkers(pickupmarkers)
  }, [storeList]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { t } = useTranslation();

  return (
    <div className='store-locator-main'>
      <Header />
      <div className='container'>
        <div className='about-us'>
          <div className="store-locator mb-5">
            <div className="row">
              <div className="col-lg-5">
                <div className='d-flex align-items-center gap-10 mb-2 web-backbtn'>
                  <GoBack />
                  <h2 className='about-title text-start mb-0'>{t("FIND_A_NEARBY_KFC")}</h2>
                </div>
              </div>
              <div className="col-lg-7">

              </div>
            </div>

            <div className="row">
              <div className="col-lg-5">
                <div className='select-selection'>
                  <div className="row">
                    <div className="col-md-6 mt-2">
                      <Paper
                        component="form"
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onSubmit={(event) => {
                          event.preventDefault();
                        }}
                      >
                        <IconButton className='search-input-btn' type="button" sx={{ p: '10px' }} aria-label="search">
                          <SearchIcon />
                        </IconButton>
                        <InputBase
                          value={query}
                          sx={{ ml: 1, flex: 1 }}
                          placeholder="Search"
                          inputProps={{ 'aria-label': 'Search' }}
                          className='input-map-search'
                          onChange={handleQuery}
                        />

                      </Paper>
                    </div>
                    <div className="col-md-6 mt-2">
                      <FormControl className='w-100 select-field-items'>
                        <InputLabel className='select-field-location' id="demo-simple-select-standard-label">{t("CITY")}</InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={city}
                          onChange={handleCity}
                          label="Age"
                          className='selected-field-location'
                          placeholder='asadsdas'
                        >
                          <MenuItem value="all">
                            All
                          </MenuItem>
                          {cityList?.map((city: any, i: any) => <MenuItem key={i} value={city?.id}>{city?.name}</MenuItem>)}

                        </Select>
                      </FormControl>
                    </div>

                  </div>
                  <Tabs
                    defaultActiveKey="All"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                    onSelect={(k: any) => {
                      setChannelTab(k);
                    }}
                  >
                    <Tab eventKey="All" title="All">
                      <div className='store-container'>
                        {filterStores?.map((item: any, index: any) => (
                          <StoreItem store={item} index={index} setSelectedStore={setSelectedStore} setZoom={setZoom} />
                        ))}
                        {filterStores.length === 0 && <h5 className='color-white p-3 text-center justify-content-center'>{t("STORES_NOT_FOUND")}</h5>}
                      </div>
                    </Tab>
                    {process.env.REACT_APP_DELIVERY_ENABLE == "true" && <Tab eventKey="Delivery" title="Delivery">
                      <div className='store-container'>
                        {filterDelivery?.map((item: any, index: any) => (
                          <StoreItem store={item} index={index} setSelectedStore={setSelectedStore} setZoom={setZoom} />
                        ))}
                        {filterDelivery.length === 0 && <h5 className='color-white p-3 text-center justify-content-center'>{t("STORES_NOT_FOUND")}</h5>}
                      </div>
                    </Tab>}
                    <Tab eventKey="Pickup" title="Pickup">
                      <div className='store-container'>
                        {filterPickup?.map((item: any, index: any) => (
                          <StoreItem store={item} index={index} setSelectedStore={setSelectedStore} setZoom={setZoom} />
                        ))}
                        {filterPickup.length === 0 && <h5 className='color-white p-3 text-center justify-content-center'>{t("STORES_NOT_FOUND")}</h5>}
                      </div>
                    </Tab>

                  </Tabs>
                </div>
              </div>
              <div className="col-lg-7 store-map-item-remove">
                {process.env.REACT_APP_GOOGLE_MAPS_ENABLE === "true" ? (
                  <StoreLocationsGoogleMap
                    zoom={zoom}
                    zoomChangeSeed={zoomChangeSeed}
                    channel={channel}
                    markers={markers}
                    deliveryMarkers={deliveryMarkers}
                    pickupMarkers={pickupMarkers}
                    initialMapCenter={initialMapCenter}
                  />
                ) : <StoreLocationsMap
                  zoom={zoom}
                  zoomChangeSeed={zoomChangeSeed}
                  channel={channel}
                  markers={markers}
                  deliveryMarkers={deliveryMarkers}
                  pickupMarkers={pickupMarkers}
                  initialMapCenter={initialMapCenter} />
                }
                {/* <LocationMap getStores={props.getStores} getCitiesWeb={props.getCitiesWeb} zoom={zoom} stores={channel == "All" ? filterStores : channel == "Delivery" ? filterDelivery : filterPickup} selectedStore={selectedStore} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
const mapDispatchToProps = (dispatch: any) => {
  return {
    getStores: function (data?: any) {
      dispatch(getStores());
    },
    getCitiesWeb: function (data: any) {
      dispatch(getCitiesWeb());
    }
  }
}
export default connect(null, mapDispatchToProps)(StoreLocator);